import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { subscriptionFormActionsV2 } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormV2Sagas'
import { useSnackbar } from 'baseui/snackbar'
import {
  selectActiveAddress,
  selectCurrentAddressData,
} from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSelectors'
import { selectAuthData } from '@/containers/Login/AuthSelectors'
import useFormStatus from '@/containers/SubscriptionFormPageNew/SubscriptionForm/useFormStatus'
import { isElectricityMeterDataReady } from '@/containers/SubscriptionFormPageNew/Components/shared/meterSaveGating'

const useElectricityMeterSave = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { enqueue } = useSnackbar()
  const { isEditable } = useFormStatus()
  const { country } = useSelector(selectAuthData)

  const activeAddress = useSelector(selectActiveAddress)
  const currentAddressData = useSelector(selectCurrentAddressData)
  const { electricityMeter = {} } = currentAddressData
  const { isSaving = false } = electricityMeter

  // Shared with the global client-tab save (CLIENT_TAB_SAVE_ALL) ─ keep the
  // gating logic in one place so the per-module button and the global save
  // never drift apart.
  const isMeterDataReady = isElectricityMeterDataReady({ electricityMeter, country })
  const canSave = isEditable && isMeterDataReady

  const saveElectricityMeter = () => {
    dispatch({
      type: subscriptionFormActionsV2.SAVE_ELECTRICITY_METER_V2,
      enqueue,
      meterData: electricityMeter,
      addressId: activeAddress,
    })
  }

  return {
    saveElectricityMeter,
    isSaving,
    isEditable,
    canSave,
    isMeterDataReady,
    t,
    electricityMeter,
    currentAddressData,
    country,
  }
}

export default useElectricityMeterSave
